//var log = console.log

// initial state
// shape: [{ id, quantity }]
const state = {
    data: {
        route_projId : 0
    },
    config: {
    }
}

// getters
const getters = {
//    auth: state => state.auth
    data : state => state.data,
    route_projId: state => state.data.route_projId
}

// actions
const actions = {
    set({ commit }, k, v) {
        commit.data(k,v)
    }
}

// mutations
const mutations = {
  data (state, k, v) {
    state.data[k] = v
  },
  route_projId (state, v) {
    state.data.route_projId = v
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
